import React from "react";
// import "./FolderSkeleton.css"; // Ensure this CSS file exists

const FolderSkeleton = ({ count = 3 }) => {
  return (
    <div className="folder-grid">
      {Array.from({ length: count }).map((_, idx) => (
        <>
          <div className="folder-card" key={idx}>
            <div className="folder-wrapper" style={{ marginBottom: "10px" }}>
              <div className="skeleton skeleton-avatar" style={{ width: "100%", height: "7rem", borderRadius:'1rem' }}></div>
              {/* <div className="folder-inner-icon skeleton-box"></div> */}
            </div>
            <div className="skeleton skeleton-text" style={{ width: "3rem", height: "0.8rem" }} />
          </div>
        </>
      ))}
    </div>
  );
};

export default FolderSkeleton;
